import * as Yup from "yup";

export const contactSchema = Yup.object({
    name: Yup.string().min(2).max(25).required("Please enter your name"),
    email: Yup.string().email().required("Please enter your email"),
    mobile: Yup.string().length(10, "Please enter a valid mobile number").required("Please enter your mobile"),
    subject: Yup.string().required("Please enter your Subject"),
    query: Yup.string().required("Please enter your query")
    
  });


  export const resetSchema = Yup.object().shape({
    email: Yup.string().email().required("Please enter your email"),
    // password: Yup.string()
    //   .min(8, 'Password must be at least 8 characters')
    //   .required('Please enter your password'),
    // confirmPassword: Yup.string()
    //   .oneOf([Yup.ref('password'), null], 'Passwords must match')
    //   .required('Please confirm your password'),
  });